/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GrandType {
    REFRESH_TOKEN = 'refresh_token',
}
